<template>
  <div class="modal-popup">
    <div class="modal fade" id="sailDeckPopup" tabindex="-1" role="dialog"  aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content" >
          <div class="modal-body">
            <div class="contact-form-action">
              <form method="post" id="sailDeckRoomDetail">
                <div class="col-sm-6" v-if="sailDeckRoom != null && sailDeckRoom.bookingDetail != null && sailDeckRoom.bookingDetail.bookingId != 0">
                  <div class="input-box">
                    <label class="label-text">Rezervasyon Bilgileri</label>
                    <a :href="basePath+'/bookings/'+sailDeckRoom.bookingDetail.bookingId" target="_blank">#{{sailDeckRoom.bookingDetail.bookingId}}</a>
                  </div>
                </div>
                <div class="col-sm-6" v-if="sailCruiseRoomRule != null">
                  <div class="input-box">
                    <label class="label-text">Maksimum Yolcu Kapasitesi</label>
                    <div class="form-group">
                      <input class="form-control" v-model="sailCruiseRoomRule.maxGuestCount" name="sailDeckMaxGuestCount" type="number" placeholder="">
                    </div>
                  </div>
                  <div class="input-box">
                    <label class="label-text">Maksimum Yetişkin Kapasitesi</label>
                    <div class="form-group">
                      <input class="form-control" v-model="sailCruiseRoomRule.maxAdultCount" name="sailDeckMaxAdultCount" type="number" placeholder="">
                    </div>
                  </div>
                  <base-select-input
                      v-model="sailCruiseRoomRule.reservedAgencyId"
                      :optionList="agencyList"
                      :label="'Rezerve edilen Acente ' + sailCruiseRoomRule.reservedAgencyId">
                  </base-select-input>
<!--                  <div class="input-box">-->
<!--                    <label class="label-text">Rezerve edilen Acente</label>-->
<!--                    <div class="form-group">-->
<!--                      <select v-model="sailCruiseRoomRule.reservedAgencyId" id="selectedAgency" class="select-contain-select" type="text" placeholder="">-->
<!--                        <option v-for="agency in agencyList" :value="agency.id"> {{agency.name}} </option>-->
<!--                      </select>-->
<!--                    </div>-->
<!--                  </div>-->
                  <div class="input-box">
                    <label class="label-text">Bloke</label>
                    <div class="form-group">
                      <input class="form-control" type="checkbox" v-model="sailCruiseRoomRule.blocked">
                    </div>
                  </div>
                  <div class="input-box" v-if="projectName === 'selectum'">
                    <label class="label-text">Ros override</label>
                    <div class="form-group">
                      <input class="form-control" type="checkbox" v-model="sailCruiseRoomRule.rosOverriding">
                    </div>
                  </div>
                  <div class="input-box" v-if="projectName === 'selectum'">
                    <label class="label-text">Ros</label>
                    <div class="form-group">
                      <input class="form-control" type="checkbox" v-model="sailCruiseRoomRule.ros">
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="modal-footer border-top-0 pt-0">
            <button type="button" class="btn font-weight-bold font-size-15 color-text-2 mr-2" data-dismiss="modal">İptal</button>
            <button :class="{'disabled' : !canPost}" @click="update" type="button" class="theme-btn theme-btn-small">Güncelle</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseSelectInput from "../base/BaseSelectInput";
export default {
  name: "SailDeckDetail",
  components: {BaseSelectInput},
  data:function (){
    return {
      canPost : true,
    }
  },
  computed:{
    projectName:{
      get() {
        return this.$store.getters.getProjectName;
      }
    },
    basePath:{
      get(){
        return this.$store.getters.getBasePath
      }
    },
    agencyList:{
      get(){
        let agencyList = this.$store.getters.getAgencyList;
        if(!agencyList) return null;

        // agencyList.push({id:null, name:"Seçimi Kaldır."})

        return agencyList;
      }
    },
    sailDeckRoom:{
      get(){
        return this.$store.getters.getSailDeckRoom
      }
    },
    sailCruiseRoomRule : {
      get(){
        if(this.sailDeckRoom != null){
          return this.sailDeckRoom.bookingDetail
        }
      }
    },
  },
  methods:{
    update(){
      let that = this;
      let request = this.sailCruiseRoomRule;
      request.cruiseRoomId = this.sailDeckRoom.id;
      request.sailId = this.$store.getters.getSail.id
      this.$store.dispatch("updateCruiseRoomRules",request)
      .then(response => {
        $(".modal").modal('hide')
        Swal.fire({
          icon: 'success',
          title: 'Başarılı',
          text: '',
        })
      })
    //  Load Sail
      setTimeout(function (){
        that.$store.dispatch("loadSailId",request.sailId);
      },1000);
    }
  },
  watch:{
    sailCruiseRoomRule:{
      deep:true,
      handler:function (){
        this.canPost = false;
        if(this.maxGuestCount > 0 && this.maxAdultCount > 0){
          this.canPost = true;
        }
      }
    }
  }
}
</script>

<style scoped>

</style>